module.exports = __webpack_public_path__ + "assets/img/d0658a5acc0e6d58d3c7d884b0627804.svg";